import { render } from "./RDataList.vue?vue&type=template&id=50547c0c"
import script from "./RDataList.vue?vue&type=script&lang=js"
export * from "./RDataList.vue?vue&type=script&lang=js"

import "./RDataList.vue?vue&type=style&index=0&id=50547c0c&lang=css"
script.render = render

export default script